import { createContext } from 'react'

export interface DynamicFormYearsContextValue {
  year: string | number | null
  lastFarmSubdivisionYear: string | number | null
}

const DEFAULT_CONTEXT: DynamicFormYearsContextValue = {
  year: null,
  lastFarmSubdivisionYear: null,
}

export const DynamicFormYearsContext = createContext<DynamicFormYearsContextValue>(DEFAULT_CONTEXT)

export const DATE_VALIDATION_CONTEXT_KEYS = Object.freeze(['metricYear', 'lastFarmSubdivisionYear'])
